// Contenido traducido para el sitio web
export const content = {
  es: {
    // Navegación
    nav: {
      about: 'Nosotros',
      gallery: 'Galería',
      services: 'Servicios',
      location: 'Ubicación',
      booking: 'Reservar'
    },
    // Hero Section
    hero: {
      title: 'Casa Colores',
      subtitle: 'Donde cada viajero se siente como en casa',
      description: 'En el corazón de Tilcara, rodeados de montañas y buenos vibes',
      cta: 'Reservar Ahora'
    },
    // About Section
    about: {
      title: 'Sobre Nosotros',
      subtitle: 'Tu base en la Quebrada de Humahuaca',
      humanSubtitle: 'Casa Colores es mucho más que un hostel: es un espacio pensado para que cada viajero se sienta en casa. Cada rincón fue creado con dedicación y refleja la esencia de quienes disfrutan compartir, conectar y vivir nuevas experiencias.',
      description: 'Casa Colores nació del amor por los viajes y la pasión por recibir gente de todo el mundo. No somos solo un hostel, somos esa segunda casa que todos necesitamos cuando andamos de ruta.',
      story: 'Es ese lugar donde llegás como turista y te vas con el corazón lleno de amigos, historias y mates compartidos viendo los cerros. Acá no hay protocolo, hay onda. Tratamos a todos como familia y cada rincón tiene su historia.',
      features: [
        'Ambiente familiar y relajado',
        'Staff local que conoce todos los secretos',
        'Conexión real con otros viajeros',
        'Vista increíble a los cerros'
      ]
    },
    // Experiences Section
    experiences: {
      title: 'La Experiencia Casa Colores',
      subtitle: 'Cada momento es una nueva historia',
      humanSubtitle: 'Cada día en Casa Colores tiene algo especial: despertarse con vista a los cerros, compartir un asado en el patio o terminar la noche entre charlas con viajeros de todo el mundo.',
      sharedSpaces: {
        title: 'Espacios Compartidos',
        description: 'Lugares para conectar'
      },
      uniqueViews: {
        title: 'Vistas Únicas',
        description: 'La Quebrada en todo su esplendor'
      },
      magicalNights: {
        title: 'Noches Mágicas',
        description: 'Bajo las estrellas del norte'
      },
      callToAction: {
        title: '¿Listo para vivir la experiencia?',
        description: 'Vení a Casa Colores y descubrí por qué cada viajero se lleva un pedacito de este lugar en el corazón.',
        button: 'Reservá Tu Lugar'
      }
    },
    // Testimonials Section
    testimonials: {
      title: 'Lo que dicen nuestros huéspedes',
      subtitle: 'Historias reales de viajeros como vos',
      humanSubtitle: 'Estas palabras nos emocionan porque reflejan lo más importante: que quienes nos visitan se llevan algo valioso. Cada reseña es una sonrisa que queda, una señal de que encontraron en Casa Colores lo que uno espera cuando viaja: sentirse bien recibido, cómodo y acompañado.',
      imageCaption: 'Despertáte con esta vista todos los días',
      reviews: [
        {
          text: 'El lugar es acogedor, colorido y lleno de buena vibra, perfecto para conocer gente o simplemente relajarse después de un día explorando Jujuy. El personal fue muy amable y las áreas comunes se sentían como en casa.',
          author: 'Natasha',
          location: 'Viajera internacional'
        },
        {
          text: 'Los dueños son súper hospitalarios, realmente lo dan todo. Las habitaciones amplias, cocina súper completa y el desayuno casero riquísimo. Esperamos volver!',
          author: 'Nicole',
          location: 'Argentina'
        },
        {
          text: 'Te hacen sentir en casa desde el primer momento. El precio incluye el desayuno argentino típico con tostadas y dulce de leche. Todo muy limpio y ordenado. Un placer quedarnos aquí!',
          author: 'María',
          location: 'Viajando con amigos'
        },
        {
          text: 'Los dueños son los encargados de hacer esta experiencia lo más cálida posible. Súper responsables y atentos a todo y a todos. Un lugar hermoso para repetir la visita.',
          author: 'Maximiliano',
          location: 'Viajero solo'
        },
        {
          text: 'Nos sentimos en casa. El trato de las personas dueñas es lo que más destacaríamos. Gran desayuno, buen patio y se respira tranquilidad. Habitaciones espaciosas y cocina completa.',
          author: 'Beñat',
          location: 'España - En pareja'
        },
        {
          text: 'El hostel es muy limpio, rústico y colorido. La cocina está bien equipada y el dueño es muy amable y servicial. Te dice cómo hacer viajes de forma independiente. La zona es muy segura.',
          author: 'Cheryl',
          location: 'Viajera internacional'
        }
      ]
    },
    // Gallery Section
    gallery: {
      title: 'Nuestros Espacios',
      subtitle: 'Cada rincón tiene su magia',
      humanSubtitle: 'Esto es Casa Colores tal como es. Momentos reales, rincones llenos de vida y la energía que nos rodea cada día.',
      categories: {
        exterior: 'La Entrada que te Recibe',
        interior: 'Adentro Todo es Calidez',
        outdoor: 'Al Aire Libre Bajo el Cielo Norteño',
        views: 'Las Vistas que te Van a Enamorar'
      },
      finalMessage: '¡Vení, tu lugar en Tilcara te está esperando!'
    },
    // Services Section
    services: {
      title: 'Servicios',
      subtitle: 'Todo lo que necesitás para tu estadía',
      humanSubtitle: 'Hemos pensado en los detalles que realmente importan para que tu estadía sea cómoda y auténtica. Todo lo que necesitás para sentirte bien está acá.',
      list: [
        {
          title: 'WiFi Gratis',
          description: 'Para subir esas fotos de los cerros al instante'
        },
        {
          title: 'Cocina Completa',
          description: 'Preparate unos mates o cocinale algo rico a tus nuevos amigos'
        },
        {
          title: 'Terraza con Vista',
          description: 'Para tomar mate mirando los cerros'
        },
        {
          title: 'Habitación Privada',
          description: 'Con y sin baño privado, para tu comodidad'
        },
        {
          title: 'Parrilla y Horno de Barro',
          description: 'Para cocinar al aire libre como los locales'
        },
        {
          title: 'Clases de Yoga',
          description: 'Relajate con vista a las montañas'
        },
        {
          title: 'Espacio Musical',
          description: 'Traé tu guitarra, acá se toca'
        },
        {
          title: 'Baños Compartidos',
          description: 'Limpios y con agua caliente siempre'
        },
        {
          title: 'Ambiente Familiar',
          description: 'Como estar en tu casa, pero con mejor vista'
        }
      ]
    },
    // Location Section
    location: {
      title: 'Ubicación',
      subtitle: 'HOSTEL CASA COLORES TILCARA',
      description: '📍 Barrio Radio Vieja Estación, Tilcara, Jujuy\n📞 +54 388 331-6388\n📸 Instagram: @casacolores.hostel',
      directions: 'Desde la terminal de Tilcara, caminá por la calle Belgrano, doblá hacia el puente y cruzá las vías del tren. Seguí caminando con las vías a tu izquierda y, entre cerros y colores, vas a encontrar el hostel justo enfrente de la estación del tren solar: una casa amarilla con puertas coloridas y alma propia. No hay forma de que lo pases por alto.',
      directionsTitle: 'Cómo llegar',
      easyToFind: 'Frente a la estación del tren solar de Tilcara',
      houseDescription: 'Nuestra casa colorida te espera en un rincón tranquilo, rodeado de montañas y buena energía.'
    },
    // Booking Section
    booking: {
      title: 'Reservar',
      subtitle: 'Contactanos para tu estadía',
      humanSubtitle: 'Escribinos y charlamos. Estamos para responder todas tus preguntas… y de paso, compartirte algún que otro dato útil para tu viaje por el norte.',
      whatsapp: 'Escribinos por WhatsApp',
      whatsappMessage: 'Hola! Me interesa hospedarme en Casa Colores. ¿Tienen disponibilidad?',
      booking: 'Ver en Booking.com',
      contact: {
        phone: '+54 388 331-6388',
        address: 'Barrio Radio Vieja Estación, Y4624 Tilcara, Jujuy'
      }
    },
    // WhatsApp Float
    whatsappFloat: {
      greeting: '¡Hola! 👋 ¿Tenés alguna consulta sobre tu estadía en Casa Colores?',
      buttonText: 'Escribir por WhatsApp',
      online: 'En línea'
    },
    // Footer
    footer: {
      slogan: 'Donde cada viaje se convierte en una historia',
      rights: 'Casa Colores Hostel. Todos los derechos reservados.'
    }
  },
  en: {
    // Navigation
    nav: {
      about: 'About Us',
      gallery: 'Gallery',
      services: 'Services',
      location: 'Location',
      booking: 'Book Now'
    },
    // Hero Section
    hero: {
      title: 'Casa Colores',
      subtitle: 'Where every traveler feels at home',
      description: 'In the heart of Tilcara, surrounded by mountains and good vibes',
      cta: 'Book Now'
    },
    // About Section
    about: {
      title: 'About Us',
      subtitle: 'Your base in Quebrada de Humahuaca',
      humanSubtitle: 'Casa Colores is more than just a hostel — it\'s a space designed to make every traveler feel at home. Every corner was created with care and reflects the spirit of those who love to share, connect, and experience new adventures.',
      description: 'Casa Colores was born from the love of travel and passion for welcoming people from around the world. We are not just a hostel, we are that second home everyone needs when on the road.',
      story: 'It\'s that place where you arrive as a tourist and leave with a heart full of friends, stories and shared mates watching the mountains. Here there\'s no protocol, just good vibes. We treat everyone like family and every corner has its story.',
      features: [
        'Family and relaxed atmosphere',
        'Local staff who knows all the secrets',
        'Real connection with other travelers',
        'Incredible mountain views'
      ]
    },
    // Experiences Section
    experiences: {
      title: 'The Casa Colores Experience',
      subtitle: 'Every moment is a new story',
      humanSubtitle: 'Every day at Casa Colores brings something special — waking up to mountain views, sharing a barbecue in the patio, or ending the night with conversations from around the world.',
      sharedSpaces: {
        title: 'Shared Spaces',
        description: 'Places to connect'
      },
      uniqueViews: {
        title: 'Unique Views',
        description: 'The Quebrada in all its splendor'
      },
      magicalNights: {
        title: 'Magical Nights',
        description: 'Under the northern stars'
      },
      callToAction: {
        title: 'Ready to live the experience?',
        description: 'Come to Casa Colores and discover why every traveler takes a piece of this place in their heart.',
        button: 'Book Your Place'
      }
    },
    // Testimonials Section
    testimonials: {
      title: 'What our guests say',
      subtitle: 'Real stories from travelers like you',
      humanSubtitle: 'These words truly move us because they reflect what matters most: that our guests leave with something meaningful. Each review is like a smile left behind — a sign that they found at Casa Colores what every traveler hopes for: feeling welcomed, comfortable, and cared for',
      imageCaption: 'Wake up to this view every day',
      reviews: [
        {
          text: 'The place is cozy, colorful and full of good vibes, perfect for meeting people or just relaxing after a day of exploring Jujuy. The staff were super friendly and the common areas felt like home.',
          author: 'Natasha',
          location: 'International traveler'
        },
        {
          text: 'The owners are super hospitable, they really give their all. Spacious rooms, super complete kitchen and delicious homemade breakfast. We hope to return!',
          author: 'Nicole',
          location: 'Argentina'
        },
        {
          text: 'They make you feel at home from the first moment. The price includes typical Argentine breakfast with toast and dulce de leche. Everything very clean and tidy. A pleasure to stay here!',
          author: 'María',
          location: 'Traveling with friends'
        },
        {
          text: 'The owners are responsible for making this experience as warm as possible. Super responsible and attentive to everything and everyone. A beautiful place to repeat the visit.',
          author: 'Maximiliano',
          location: 'Solo traveler'
        },
        {
          text: 'We felt at home. The treatment from the owners is what we would highlight the most. Great breakfast, nice patio and you can breathe tranquility. Spacious rooms and complete kitchen.',
          author: 'Beñat',
          location: 'Spain - Couple'
        },
        {
          text: 'The hostel is very clean, rustic and colorful. The kitchen is well equipped and the owner is very kind and helpful. He will tell you how to do trips independently. The area is very safe.',
          author: 'Cheryl',
          location: 'International traveler'
        }
      ]
    },
    // Gallery Section
    gallery: {
      title: 'Our Spaces',
      subtitle: 'Every corner has its magic',
      humanSubtitle: 'Every image captures a piece of what life feels like here: colors, mountains, shared stories, and the magic of simplicity.',
      categories: {
        exterior: 'The Welcome That Greets You',
        interior: 'Inside Everything is Warmth',
        outdoor: 'Outdoors Under the Northern Sky',
        views: 'The Views That Will Make You Fall in Love'
      },
      finalMessage: 'Come, your place in Tilcara is waiting for you!'
    },
    // Services Section
    services: {
      title: 'Services',
      subtitle: 'Everything you need for your stay',
      humanSubtitle: 'We\'ve thought about the details that really matter to make your stay comfortable and authentic. Everything you need to feel good is here.',
      list: [
        {
          title: 'Free WiFi',
          description: 'To upload those mountain photos instantly'
        },
        {
          title: 'Full Kitchen',
          description: 'Make some mate or cook something nice for your new friends'
        },
        {
          title: 'Terrace with View',
          description: 'To drink mate watching the mountains'
        },
        {
          title: 'Private Room',
          description: 'With and without private bathroom, for your comfort'
        },
        {
          title: 'Grill and Clay Oven',
          description: 'To cook outdoors like the locals'
        },
        {
          title: 'Yoga Classes',
          description: 'Relax with mountain views'
        },
        {
          title: 'Music Space',
          description: 'Bring your guitar, music happens here'
        },
        {
          title: 'Shared Bathrooms',
          description: 'Clean and with hot water always'
        },
        {
          title: 'Family Atmosphere',
          description: 'Like being at home, but with better views'
        }
      ]
    },
    // Location Section
    location: {
      title: 'Location',
      subtitle: 'HOSTEL CASA COLORES TILCARA',
      description: '📍 Barrio Radio Vieja Estación, Tilcara, Jujuy\n📞 +54 388 331-6388\n📸 Instagram: @casacolores.hostel',
      directions: 'From Tilcara terminal, walk along Belgrano street, turn towards the bridge and cross the train tracks. Keep walking with the tracks on your left and, among hills and colors, you will find the hostel right in front of the solar train station: a yellow house with colorful doors and its own soul. There is no way you can miss it.',
      directionsTitle: 'How to get here',
      easyToFind: 'In front of Tilcara solar train station',
      houseDescription: 'Our colorful house awaits you in a quiet corner, surrounded by mountains and good energy.'
    },
    // Booking Section
    booking: {
      title: 'Book Now',
      subtitle: 'Contact us for your stay',
      humanSubtitle: 'Send us a message — we’re happy to answer any questions and share a few helpful tips for your journey through the north.',
      whatsapp: 'Message us on WhatsApp',
      whatsappMessage: 'Hello! I\'m interested in staying at Casa Colores. Do you have availability?',
      booking: 'View on Booking.com',
      contact: {
        phone: '+54 388 331-6388',
        address: 'Barrio Radio Vieja Estación, Y4624 Tilcara, Jujuy'
      }
    },
    // WhatsApp Float
    whatsappFloat: {
      greeting: 'Hello! 👋 Do you have any questions about your stay at Casa Colores?',
      buttonText: 'Chat on WhatsApp',
      online: 'Online'
    },
    // Footer
    footer: {
      slogan: 'Where every trip becomes a story',
      rights: 'All rights reserved.'
    }
  },
  pt: {
    // Navegação
    nav: {
      about: 'Sobre Nós',
      gallery: 'Galeria',
      services: 'Serviços',
      location: 'Localização',
      booking: 'Reservar'
    },
    // Hero Section
    hero: {
      title: 'Casa Colores',
      subtitle: 'Onde cada viajante se sente em casa',
      description: 'No coração de Tilcara, cercados de montanhas e boas vibrações',
      cta: 'Reservar Agora'
    },
    // About Section
    about: {
      title: 'Sobre Nós',
      subtitle: 'Sua base na Quebrada de Humahuaca',
      humanSubtitle: 'Casa Colores é muito mais que um hostel: é um espaço pensado para que cada viajante se sinta em casa. Cada cantinho foi criado com dedicação e reflete a essência de quem gosta de compartilhar, conectar e viver novas experiências.',
      description: 'Casa Colores nasceu do amor pelas viagens e da paixão por receber gente do mundo todo. Não somos só um hostel, somos aquela segunda casa que todos precisamos quando estamos viajando.',
      story: 'É aquele lugar onde você chega como turista e vai embora com o coração cheio de amigos, histórias e chimarrões compartilhados olhando as montanhas. Aqui não tem protocolo, tem onda boa. Tratamos todos como família e cada cantinho tem sua história.',
      features: [
        'Ambiente familiar e relaxado',
        'Equipe local que conhece todos os segredos',
        'Conexão real com outros viajantes',
        'Vista incrível das montanhas'
      ]
    },
    // Experiences Section
    experiences: {
      title: 'A Experiência Casa Colores',
      subtitle: 'Cada momento é uma nova história',
      humanSubtitle: 'Cada dia na Casa Colores tem algo especial: acordar com vista das montanhas, compartilhar um churrasco no pátio ou terminar a noite conversando com viajantes do mundo todo.',
      sharedSpaces: {
        title: 'Espaços Compartilhados',
        description: 'Lugares para conectar'
      },
      uniqueViews: {
        title: 'Vistas Únicas',
        description: 'A Quebrada em todo seu esplendor'
      },
      magicalNights: {
        title: 'Noites Mágicas',
        description: 'Sob as estrelas do norte'
      },
      callToAction: {
        title: 'Pronto para viver a experiência?',
        description: 'Venha para Casa Colores e descubra por que cada viajante leva um pedacinho deste lugar no coração.',
        button: 'Reserve Seu Lugar'
      }
    },
    // Testimonials Section
    testimonials: {
      title: 'O que dizem nossos hóspedes',
      subtitle: 'Histórias reais de viajantes como você',
      humanSubtitle: 'Essas palavras nos emocionam porque refletem o mais importante: que quem nos visita leva algo valioso. Cada avaliação é um sorriso que fica, um sinal de que encontraram na Casa Colores o que se espera quando viaja: sentir-se bem recebido, confortável e acompanhado.',
      imageCaption: 'Acorde com essa vista todos os dias',
      reviews: [
        {
          text: 'O lugar é acolhedor, colorido e cheio de boa vibração, perfeito para conhecer gente ou simplesmente relaxar depois de um dia explorando Jujuy. A equipe foi muito simpática e as áreas comuns pareciam como em casa.',
          author: 'Natasha',
          location: 'Viajante internacional'
        },
        {
          text: 'Os donos são super hospitaleiros, realmente dão tudo de si. Quartos amplos, cozinha super completa e café da manhã caseiro delicioso. Esperamos voltar!',
          author: 'Nicole',
          location: 'Argentina'
        },
        {
          text: 'Te fazem sentir em casa desde o primeiro momento. O preço inclui café da manhã argentino típico com torradas e doce de leite. Tudo muito limpo e organizado. Um prazer ficar aqui!',
          author: 'María',
          location: 'Viajando com amigos'
        },
        {
          text: 'Os donos são os responsáveis por tornar essa experiência o mais calorosa possível. Super responsáveis e atentos a tudo e todos. Um lugar lindo para repetir a visita.',
          author: 'Maximiliano',
          location: 'Viajante solo'
        },
        {
          text: 'Nos sentimos em casa. O tratamento dos proprietários é o que mais destacaríamos. Ótimo café da manhã, bom pátio e respira-se tranquilidade. Quartos espaçosos e cozinha completa.',
          author: 'Beñat',
          location: 'Espanha - Em casal'
        },
        {
          text: 'O hostel é muito limpo, rústico e colorido. A cozinha está bem equipada e o dono é muito gentil e prestativo. Te explica como fazer viagens de forma independente. A área é muito segura.',
          author: 'Cheryl',
          location: 'Viajante internacional'
        }
      ]
    },
    // Gallery Section
    gallery: {
      title: 'Nossos Espaços',
      subtitle: 'Cada cantinho tem sua magia',
      humanSubtitle: 'Isso é Casa Colores tal como é. Momentos reais, cantinhos cheios de vida e a energia que nos rodeia a cada dia.',
      categories: {
        exterior: 'A Entrada que te Recebe',
        interior: 'Por Dentro Tudo é Aconchego',
        outdoor: 'Ao Ar Livre Sob o Céu do Norte',
        views: 'As Vistas que Vão te Apaixonar'
      },
      finalMessage: 'Venha, seu lugar em Tilcara está te esperando!'
    },
    // Services Section
    services: {
      title: 'Serviços',
      subtitle: 'Tudo que você precisa para sua estadia',
      humanSubtitle: 'Pensamos nos detalhes que realmente importam para que sua estadia seja confortável e autêntica. Tudo que você precisa para se sentir bem está aqui.',
      list: [
        {
          title: 'WiFi Grátis',
          description: 'Para postar essas fotos das montanhas na hora'
        },
        {
          title: 'Cozinha Completa',
          description: 'Prepare um chimarrão ou cozinhe algo gostoso para seus novos amigos'
        },
        {
          title: 'Terraço com Vista',
          description: 'Para tomar chimarrão olhando as montanhas'
        },
        {
          title: 'Quarto Privado',
          description: 'Com e sem banheiro privado, para seu conforto'
        },
        {
          title: 'Churrasqueira e Forno de Barro',
          description: 'Para cozinhar ao ar livre como os locais'
        },
        {
          title: 'Aulas de Yoga',
          description: 'Relaxe com vista das montanhas'
        },
        {
          title: 'Espaço Musical',
          description: 'Traga seu violão, aqui rola música'
        },
        {
          title: 'Banheiros Compartilhados',
          description: 'Limpos e com água quente sempre'
        },
        {
          title: 'Ambiente Familiar',
          description: 'Como estar em sua casa, mas com vista melhor'
        }
      ]
    },
    // Location Section
    location: {
      title: 'Localização',
      subtitle: 'HOSTEL CASA COLORES TILCARA',
      description: '📍 Barrio Radio Vieja Estación, Tilcara, Jujuy\n📞 +54 388 331-6388\n📸 Instagram: @casacolores.hostel',
      directions: 'Do terminal de Tilcara, caminhe pela rua Belgrano, vire em direção à ponte e atravesse os trilhos do trem. Continue caminhando com os trilhos à sua esquerda e, entre montanhas e cores, você encontrará o hostel bem em frente à estação do trem solar: uma casa amarela com portas coloridas e alma própria. Não tem como passar despercebido.',
      directionsTitle: 'Como chegar',
      easyToFind: 'Em frente à estação do trem solar de Tilcara',
      houseDescription: 'Nossa casa colorida te espera num cantinho tranquilo, cercada de montanhas e boa energia.'
    },
    // Booking Section
    booking: {
      title: 'Reservar',
      subtitle: 'Entre em contato para sua estadia',
      humanSubtitle: 'Nos escreva e vamos conversar. Estamos aqui para responder todas suas perguntas... e de quebra, compartilhar algumas dicas úteis para sua viagem pelo norte.',
      whatsapp: 'Nos escreva pelo WhatsApp',
      whatsappMessage: 'Olá! Tenho interesse em me hospedar na Casa Colores. Vocês têm disponibilidade?',
      booking: 'Ver no Booking.com',
      contact: {
        phone: '+54 388 331-6388',
        address: 'Barrio Radio Vieja Estación, Y4624 Tilcara, Jujuy'
      }
    },
    // WhatsApp Float
    whatsappFloat: {
      greeting: 'Olá! 👋 Tem alguma pergunta sobre sua estadia na Casa Colores?',
      buttonText: 'Escrever pelo WhatsApp',
      online: 'Online'
    },
    // Footer
    footer: {
      slogan: 'Onde cada viagem se converte numa história',
      rights: 'Casa Colores Hostel. Todos os direitos reservados.'
    }
  },
  fr: {
    // Navigation
    nav: {
      about: 'À Propos',
      gallery: 'Galerie',
      services: 'Services',
      location: 'Localisation',
      booking: 'Réserver'
    },
    // Hero Section
    hero: {
      title: 'Casa Colores',
      subtitle: 'Où chaque voyageur se sent chez lui',
      description: 'Au cœur de Tilcara, entourés de montagnes et de bonnes vibrations',
      cta: 'Réserver Maintenant'
    },
    // About Section
    about: {
      title: 'À Propos de Nous',
      subtitle: 'Votre base dans la Quebrada de Humahuaca',
      humanSubtitle: 'Casa Colores est bien plus qu\'une auberge : c\'est un espace pensé pour que chaque voyageur se sente chez lui. Chaque coin a été créé avec soin et reflète l\'essence de ceux qui aiment partager, se connecter et vivre de nouvelles expériences.',
      description: 'Casa Colores est née de l\'amour du voyage et de la passion d\'accueillir des gens du monde entier. Nous ne sommes pas seulement une auberge, nous sommes cette seconde maison dont tout le monde a besoin en voyage.',
      story: 'C\'est cet endroit où vous arrivez en tant que touriste et repartez le cœur plein d\'amis, d\'histoires et de matés partagés en regardant les montagnes. Ici, il n\'y a pas de protocole, il y a de bonnes vibes. Nous traitons tout le monde comme une famille et chaque coin a son histoire.',
      features: [
        'Ambiance familiale et détendue',
        'Équipe locale qui connaît tous les secrets',
        'Connexion réelle avec d\'autres voyageurs',
        'Vue incroyable sur les montagnes'
      ]
    },
    // Experiences Section
    experiences: {
      title: 'L\'Expérience Casa Colores',
      subtitle: 'Chaque moment est une nouvelle histoire',
      humanSubtitle: 'Chaque jour à Casa Colores a quelque chose de spécial : se réveiller avec vue sur les montagnes, partager un barbecue dans le patio ou finir la soirée en conversation avec des voyageurs du monde entier.',
      sharedSpaces: {
        title: 'Espaces Partagés',
        description: 'Lieux pour se connecter'
      },
      uniqueViews: {
        title: 'Vues Uniques',
        description: 'La Quebrada dans toute sa splendeur'
      },
      magicalNights: {
        title: 'Nuits Magiques',
        description: 'Sous les étoiles du nord'
      },
      callToAction: {
        title: 'Prêt à vivre l\'expérience ?',
        description: 'Venez à Casa Colores et découvrez pourquoi chaque voyageur emporte un morceau de cet endroit dans son cœur.',
        button: 'Réservez Votre Place'
      }
    },
    // Testimonials Section
    testimonials: {
      title: 'Ce que disent nos hôtes',
      subtitle: 'Histoires vraies de voyageurs comme vous',
      humanSubtitle: 'Ces mots nous émeuvent vraiment car ils reflètent ce qui compte le plus : que nos invités repartent avec quelque chose de précieux. Chaque avis est comme un sourire laissé derrière - un signe qu\'ils ont trouvé à Casa Colores ce que tout voyageur espère : se sentir accueilli, confortable et accompagné.',
      imageCaption: 'Réveillez-vous avec cette vue chaque jour',
      reviews: [
        {
          text: 'L\'endroit est accueillant, coloré et plein de bonnes vibrations, parfait pour rencontrer des gens ou simplement se détendre après une journée d\'exploration de Jujuy. Le personnel était très sympathique et les espaces communs donnaient l\'impression d\'être à la maison.',
          author: 'Natasha',
          location: 'Voyageuse internationale'
        },
        {
          text: 'Les propriétaires sont super hospitaliers, ils donnent vraiment tout. Chambres spacieuses, cuisine super complète et petit-déjeuner maison délicieux. Nous espérons revenir !',
          author: 'Nicole',
          location: 'Argentine'
        },
        {
          text: 'Ils vous font sentir chez vous dès le premier moment. Le prix comprend le petit-déjeuner argentin typique avec toasts et dulce de leche. Tout très propre et rangé. Un plaisir de séjourner ici !',
          author: 'María',
          location: 'Voyage entre amis'
        },
        {
          text: 'Les propriétaires sont responsables de rendre cette expérience aussi chaleureuse que possible. Super responsables et attentifs à tout et à tous. Un bel endroit pour répéter la visite.',
          author: 'Maximiliano',
          location: 'Voyageur solo'
        },
        {
          text: 'Nous nous sommes sentis chez nous. Le traitement des propriétaires est ce que nous soulignerions le plus. Excellent petit-déjeuner, beau patio et on respire la tranquillité. Chambres spacieuses et cuisine complète.',
          author: 'Beñat',
          location: 'Espagne - En couple'
        },
        {
          text: 'L\'auberge est très propre, rustique et colorée. La cuisine est bien équipée et le propriétaire est très gentil et serviable. Il vous explique comment faire des voyages de manière indépendante. Le quartier est très sûr.',
          author: 'Cheryl',
          location: 'Voyageuse internationale'
        }
      ]
    },
    // Gallery Section
    gallery: {
      title: 'Nos Espaces',
      subtitle: 'Chaque coin a sa magie',
      humanSubtitle: 'Chaque image capture un morceau de ce que la vie ressent ici : couleurs, montagnes, histoires partagées, et la magie de la simplicité.',
      categories: {
        exterior: 'L\'Accueil qui Vous Reçoit',
        interior: 'À l\'Intérieur Tout est Chaleur',
        outdoor: 'En Plein Air Sous le Ciel du Nord',
        views: 'Les Vues qui Vont Vous Faire Tomber Amoureux'
      },
      finalMessage: 'Venez, votre place à Tilcara vous attend !'
    },
    // Services Section
    services: {
      title: 'Services',
      subtitle: 'Tout ce dont vous avez besoin pour votre séjour',
      humanSubtitle: 'Nous avons pensé aux détails qui comptent vraiment pour rendre votre séjour confortable et authentique. Tout ce dont vous avez besoin pour vous sentir bien est ici.',
      list: [
        {
          title: 'WiFi Gratuit',
          description: 'Pour publier ces photos de montagnes instantanément'
        },
        {
          title: 'Cuisine Complète',
          description: 'Préparez un maté ou cuisinez quelque chose de bon pour vos nouveaux amis'
        },
        {
          title: 'Terrasse avec Vue',
          description: 'Pour boire le maté en regardant les montagnes'
        },
        {
          title: 'Chambre Privée',
          description: 'Avec et sans salle de bain privée, pour votre confort'
        },
        {
          title: 'Barbecue et Four en Argile',
          description: 'Pour cuisiner en plein air comme les locaux'
        },
        {
          title: 'Cours de Yoga',
          description: 'Détendez-vous avec vue sur les montagnes'
        },
        {
          title: 'Espace Musical',
          description: 'Apportez votre guitare, la musique se fait ici'
        },
        {
          title: 'Salles de Bain Partagées',
          description: 'Propres et avec eau chaude toujours'
        },
        {
          title: 'Ambiance Familiale',
          description: 'Comme être chez soi, mais avec une meilleure vue'
        }
      ]
    },
    // Location Section
    location: {
      title: 'Localisation',
      subtitle: 'AUBERGE CASA COLORES TILCARA',
      description: '📍 Barrio Radio Vieja Estación, Tilcara, Jujuy\n📞 +54 388 331-6388\n📸 Instagram: @casacolores.hostel',
      directions: 'Depuis le terminal de Tilcara, marchez le long de la rue Belgrano, tournez vers le pont et traversez les voies ferrées. Continuez à marcher avec les voies à votre gauche et, entre collines et couleurs, vous trouverez l\'auberge juste en face de la gare solaire : une maison jaune avec des portes colorées et une âme propre. Impossible de la manquer.',
      directionsTitle: 'Comment arriver',
      easyToFind: 'En face de la gare solaire de Tilcara',
      houseDescription: 'Notre maison colorée vous attend dans un coin tranquille, entourée de montagnes et de bonne énergie.'
    },
    // Booking Section
    booking: {
      title: 'Réserver',
      subtitle: 'Contactez-nous pour votre séjour',
      humanSubtitle: 'Écrivez-nous — nous sommes heureux de répondre à toutes vos questions et de partager quelques conseils utiles pour votre voyage dans le nord.',
      whatsapp: 'Écrivez-nous sur WhatsApp',
      whatsappMessage: 'Bonjour ! Je suis intéressé(e) à séjourner à Casa Colores. Avez-vous de la disponibilité ?',
      booking: 'Voir sur Booking.com',
      contact: {
        phone: '+54 388 331-6388',
        address: 'Barrio Radio Vieja Estación, Y4624 Tilcara, Jujuy'
      }
    },
    // WhatsApp Float
    whatsappFloat: {
      greeting: 'Bonjour ! 👋 Avez-vous des questions sur votre séjour à Casa Colores ?',
      buttonText: 'Écrire sur WhatsApp',
      online: 'En ligne'
    },
    // Footer
    footer: {
      slogan: 'Où chaque voyage devient une histoire',
      rights: 'Casa Colores Auberge. Tous droits réservés.'
    }
  }
};
